import {Component, inject, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {LigneParametrageFacturation} from "../../../../core/models/facturation/client/ligne-parametrage-facturation";
import {FacturationClientService} from "../../../../core/services/entities/facturation-client.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {TaxeDTO} from "../../../../core/dtos/taxe-dto";
import {ElementFacturableDTO} from "../../../../core/dtos/ElementFacturableDTO";
import {FraisFixeDTO} from "../../../../core/dtos/frais-fixe-dto";
import {ElementFacturableService} from "../../../../core/services/entities/element-facturable.service";
import {TaxesService} from "../../../../core/services/entities/taxes.service";
import {FraisFixeService} from "../../../../core/services/entities/frais-fixe.service";
import {LigneParametrageFacturationChanges} from "../../../../core/models/facturation/client/ligne-parametrage-facturation-changes";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {LigneParametrageDataGridComponent} from "../ligne-parametrage-data-grid/ligne-parametrage-data-grid.component";
import {applyTauxOrPrixToPeriodeList} from "../../../../core/models/facturation/client/periode-parametrage-facturation";
import {PeriodeParametrageFacturationFraisFixe} from "../../../../core/models/facturation/client/periode-parametrage-facturation-frais-fixe";
import moment from "moment";
import {TypePeriodeFacturationEnum} from "../../../../core/enums/facturation/client/type-periode-facturation-enum";
import LigneParametrageFactureClientFilterDto from "../../../../core/dtos/facturation/clients/factures/ligne-parametrage-facture-client-filter-dto";
import {TypeFactureClientEnum} from "../../../../core/enums/facturation/client/type-facture-client-enum";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
  selector: 'yo-facturation-client-parametrage',
  templateUrl: './facturation-client-parametrage.component.html',
  styleUrls: ['./facturation-client-parametrage.component.scss'],
  standalone: false
})
export class FacturationClientParametrageComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  subData: Subscription;
  subSave: Subscription;
  subToAdd: Subscription;

  public readonly TypeFactureClientEnum = TypeFactureClientEnum;

  // region Propriétés grille de paramétrage

  @ViewChild("grid") grid: LigneParametrageDataGridComponent;

  public ligneParametrageList: LigneParametrageFacturation[] = [];

  public gridChanges: LigneParametrageFacturationChanges = new LigneParametrageFacturationChanges();

  // endregion

  // region Propriétés popup de modification de masse

  public isModificationPopupDisplayed: boolean = false;

  public isPeriodePopupDisplayed: boolean = false;

  public selectedElementFacturable: any;
  public selectedTaxe: any;
  public selectedFraisFixe: any;
  public selectedTaxeFF: any;
  public selectedPrix: any;
  public selectedTaux: any;
  public selectedFraisFixeHT: any;
  public selectedTauxFraisFixeHT: any;
  public dateSelectedPrix: Date = new Date();
  public dateSelectedFraisFixe: Date = new Date();

  //endregion

  // region Propriétés popup de modification avant ajout

  @ViewChild("gridPopup") gridPopup: LigneParametrageDataGridComponent;

  public isEditLinesPopupDisplayed = false;

  public ligneToAddList: LigneParametrageFacturation[] = [];

  private gridEditChanges: LigneParametrageFacturationChanges = new LigneParametrageFacturationChanges();

  // endregion


  readonly elementFacturableResource = inject(ElementFacturableService).elementFacturableResource;
  readonly taxeResource = inject(TaxesService).taxeList;
  readonly fraisFixeAuCouvert = inject(FraisFixeService).fraisFixeResource(['AU_COUVERT']);

  constructor(private facturationClientSvc: FacturationClientService,
              private utilsSvc: UtilsService,
              private toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.initData();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subData);
    this.utilsSvc.unsubscribe(this.subSave);
    this.utilsSvc.unsubscribe(this.subToAdd);
  }

  private initData(): void {
    this.loadData();
  }

  public loadData(typePeriode: TypePeriodeFacturationEnum[] = []) {
    const filter = new LigneParametrageFactureClientFilterDto(typePeriode, TypeFactureClientEnum.FACTURE_CLIENT_PRESTATION);
    this.subData = this.facturationClientSvc.findAllLignesParametrage(filter).subscribe(result => {
      if (result)
        this.ligneParametrageList = result;
    });
  }

  public retrieveNewLigneParametrage(newLignesParametrage: LigneParametrageFacturation[]) {
    this.ligneToAddList = newLignesParametrage;
    this.isEditLinesPopupDisplayed = true;
  }

  expandAddArea() {
    this.facturationClientSvc.announceOpenAddingAreaLigneParametrage();
  }


  openModificationPopup() {
    this.selectedElementFacturable = null;
    this.selectedTaxe = null;
    this.selectedFraisFixe = null;
    this.selectedTaxeFF = null;

    this.isModificationPopupDisplayed = true;
  }

  openPeriodePopup() {
    this.selectedPrix = null;
    this.selectedTaux = null;
    this.selectedFraisFixeHT = null;
    this.selectedTauxFraisFixeHT = null;
    this.isPeriodePopupDisplayed = true;
  }

  save() {
    this.subSave = this.facturationClientSvc.saveLignesParametrage(this.gridChanges).subscribe(result => {
      if (!this.utilsSvc.isResponseSupplierError(result)) {
        this.gridChanges.clear();
        this.loadData();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, 'Le paramétrage a été enregistré avec succès');
      }
    });
  }

  saveEditedLines() {
    this.subSave = this.facturationClientSvc.saveLignesParametrage(this.gridEditChanges).subscribe(result => {
      this.gridEditChanges.clear();
      this.ligneToAddList = [];
      this.mergeLines(result.resultList);
      this.closeEditLinesPopup();
    })
  }

  private mergeLines(lines: LigneParametrageFacturation[]) {
    lines.forEach(line => {
      let index = this.ligneParametrageList.findIndex(i => i.id === line.id);

      if (index >= 0) {
        Object.assign(this.ligneParametrageList[index], line);
        this.gridChanges.revert(line);
      } else
        this.ligneParametrageList.push(line);
    });
  }

  delete() {
    let selected = this.grid.getSelectedData();
    selected.forEach(toDelete => {
      this.gridChanges.delete(toDelete);
    });
    this.ligneParametrageList = this.ligneParametrageList.filter(item => !selected.includes(item.id));
  }


  applyModifications() {
    if (this.selectedPrix && this.selectedPrix < 0) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, "Le prix doit être supérieur à 0")
      return;
    }

    let selectedLines = this.isEditLinesPopupDisplayed ? this.gridPopup.getSelectedData() : this.grid.getSelectedData();
    let lignes = this.isEditLinesPopupDisplayed ? this.ligneToAddList : this.ligneParametrageList;
    let changes = this.isEditLinesPopupDisplayed ? this.gridEditChanges : this.gridChanges;

    let elementFacturable = undefined;
    let taxe = undefined;

    if (this.selectedElementFacturable)
      elementFacturable = (this.elementFacturableResource.value() ?? []).find(element => element.id === this.selectedElementFacturable);

    if (this.selectedTaxe)
      taxe = (this.taxeResource.value() ?? []).find(taxe => taxe.id === this.selectedTaxe);

    let fraisFixe = undefined;
    let taxeFF = undefined;

    if (this.selectedFraisFixe)
      fraisFixe = (this.fraisFixeAuCouvert.value() ?? []).find(f => f.id === this.selectedFraisFixe);

    if (this.selectedTaxeFF)
      taxeFF = (this.taxeResource.value() ?? []).find(t => t.id === this.selectedTaxeFF);

    lignes.filter(line => selectedLines.includes(line.id))
      .forEach(line => {
        if (elementFacturable) {
          line.elementFacturableId = elementFacturable.id;
          line.elementFacturableLibelle = elementFacturable.libelle
        }

        if (taxe) {
          line.taxeEFId = taxe.id;
          line.taxeEFLibelle = taxe.libelle;
        }

        if (fraisFixe) {
          line.fraisFixeId = fraisFixe.id;
          line.fraisFixeLibelle = fraisFixe.libelle;
        }

        if (taxeFF) {
          line.taxeFFId = taxeFF.id;
          line.taxeFFLibelle = taxeFF.libelle;
        }

        changes.apply(line);
      });

    this.closeModificationPopup();
  }

  applyPeriodePrix() {
    let selectedLines = this.isEditLinesPopupDisplayed ? this.gridPopup.getSelectedData() : this.grid.getSelectedData();
    let lignes = this.isEditLinesPopupDisplayed ? this.ligneToAddList : this.ligneParametrageList;
    let changes = this.isEditLinesPopupDisplayed ? this.gridEditChanges : this.gridChanges;

    lignes.filter(line => selectedLines.includes(line.id))
      .forEach(line => {
        const updatedList = applyTauxOrPrixToPeriodeList(line.periodeParametrageFacturationList, this.dateSelectedPrix, this.selectedPrix, this.selectedTaux);
        if (!updatedList) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, "Aucun prix de vente défini pour appliquer un taux de revalorisation");
          return;
        }
        line.periodeParametrageFacturationList = updatedList;
        changes.apply(line);
      });

    this.closePeriodePopup();
  }

  closeModificationPopup() {
    this.isModificationPopupDisplayed = false;
  }

  closePeriodePopup() {
    this.isPeriodePopupDisplayed = false;
  }

  applyPeriodeParametrageFacturationFraisFixe() {
    let selectedLines = this.isEditLinesPopupDisplayed ? this.gridPopup.getSelectedData() : this.grid.getSelectedData();
    let lignes = this.isEditLinesPopupDisplayed ? this.ligneToAddList : this.ligneParametrageList;
    let changes = this.isEditLinesPopupDisplayed ? this.gridEditChanges : this.gridChanges;

    lignes.filter(line => selectedLines.includes(line.id))
      .forEach(line => {
        this.updateOrAddPeriodeParametrageFacturationFraisFixe(line.periodeParametrageFacturationFraisFixeList);
        changes.apply(line);
      });

    this.closePeriodePopup();
  }

  updateOrAddPeriodeParametrageFacturationFraisFixe(list: PeriodeParametrageFacturationFraisFixe[]): PeriodeParametrageFacturationFraisFixe[] {
    const index = list
      .findIndex(item => moment(item.dateDebut).isSame(moment(this.utilsSvc.formatDate(this.dateSelectedFraisFixe)), 'day') || moment(item.dateDebut).isSame(moment(this.dateSelectedFraisFixe), 'day'));

    let lastPeriode: PeriodeParametrageFacturationFraisFixe;
    if (list && list.length > 0) {
      lastPeriode = list.reduce((latest, current) =>
        moment(current.dateDebut).isAfter(moment(latest.dateDebut))
          ? current
          : latest
      );
    }

    if (index !== -1) {
      list[index].fraisFixeHT = this.selectedTauxFraisFixeHT ? list[index].fraisFixeHT * ((this.selectedTauxFraisFixeHT / 100) + 1) : this.selectedFraisFixeHT;
    } else {
      if (this.selectedTauxFraisFixeHT && !lastPeriode) {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, "Aucun frais fixe défini pour appliquer un taux de revalorisation");
        return list;
      }
      let newFraisFixeHT = this.selectedTauxFraisFixeHT ? lastPeriode.fraisFixeHT * ((this.selectedTauxFraisFixeHT / 100) + 1) : this.selectedFraisFixeHT;
      list.push({
        id: null,
        dateDebut: this.dateSelectedFraisFixe,
        fraisFixeHT: newFraisFixeHT,
        periodeToDelete: false
      });
      list.sort((a, b) =>
        moment(a.dateDebut).diff(moment(b.dateDebut), 'day')
      );
      const indexInsertion = list.findIndex(item =>
        moment(item.dateDebut).isSame(moment(this.utilsSvc.formatDate(this.dateSelectedFraisFixe)), 'day') || moment(item.dateDebut).isSame(moment(this.dateSelectedFraisFixe), 'day')
      );
      list.forEach((item, idx) => {
        item.periodeToDelete = idx > indexInsertion;
      });
    }

    return list;
  }

  updateElementFacturable(data: any) {
    this.selectedElementFacturable = data;
    this.selectedTaxe = (this.elementFacturableResource.value() ?? []).filter(elem => elem.id == data)[0].taxe.id;
  }

  updateTaxe(data: any) {
    this.selectedTaxe = data;
  }

  updateFraisFixe(data: any) {
    this.selectedFraisFixe = data;
    this.selectedTaxeFF = (this.fraisFixeAuCouvert.value() ?? []).find(f => f.id === data)?.taxe?.id;
  }

  updateTaxeFF(data: any) {
    this.selectedTaxeFF = data;
  }

  closeEditLinesPopup() {
    this.isEditLinesPopupDisplayed = false;
    this.gridEditChanges = new LigneParametrageFacturationChanges();
    this.ligneToAddList = [];
  }

  isRowSelected() {
    return this.grid?.getSelectedData().length > 0;
  }

  isPopupRowSelected() {
    return this.gridPopup?.getSelectedData().length > 0;
  }

  canAddValues() {
    return this.ligneToAddList.filter(ligne => ligne.elementFacturableId > 0 && ligne.taxeEFId > 0 && ligne.periodeParametrageFacturationList.length > 0).length == this.ligneToAddList.length;
  }

  getTaxeDisplayValue(taxe: TaxeDTO) {
    return `${taxe.libelle} - ${taxe.valeur}%`
  }

  getElementFacturableDisplayValue = (element: ElementFacturableDTO) =>
    `${element.libelle} - ${element.code}`;

  getFraisFixeDisplayValue = (fraisFixe: FraisFixeDTO) =>
    `${fraisFixe.libelle} - ${fraisFixe.code}`;

  onChangeDatePrix(date: Date) {
    this.dateSelectedPrix = date;
  }

  onChangeDateFraisFixe(date: Date) {
    this.dateSelectedFraisFixe = date;
  }
}
